"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _utils = require("@alycecom/utils");

var _BaseSettingsItem = _interopRequireDefault(require("../BaseSettingsItem/BaseSettingsItem"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    button: {
      color: palette.link.main,
      border: "1px solid ".concat(palette.divider),
      backgroundColor: palette.common.white,
      boxShadow: 'none',
      width: 100,
      '&:hover': {
        backgroundColor: palette.grey.A200
      }
    },
    collapseWrapper: {
      width: '100%'
    }
  };
});

var SettingsItem = function SettingsItem(_ref2) {
  var title = _ref2.title,
      isLoading = _ref2.isLoading,
      children = _ref2.children,
      _ref2$collapsible = _ref2.collapsible,
      collapsible = _ref2$collapsible === void 0 ? true : _ref2$collapsible,
      open = _ref2.open,
      badge = _ref2.badge,
      icon = _ref2.icon,
      hint = _ref2.hint,
      _ref2$buttonCta = _ref2.buttonCta,
      buttonCta = _ref2$buttonCta === void 0 ? 'Change' : _ref2$buttonCta,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      baseSettingsProps = (0, _objectWithoutProperties2.default)(_ref2, ["title", "isLoading", "children", "collapsible", "open", "badge", "icon", "hint", "buttonCta", "disabled"]);

  var _useState = (0, _react.useState)(!collapsible),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var toggleExpand = function toggleExpand() {
    setIsExpanded(!isExpanded);
  };

  var classes = useStyles();
  (0, _react.useEffect)(function () {
    if (open !== undefined) {
      setIsExpanded(open);
    }
  }, [open]);
  return /*#__PURE__*/_react.default.createElement(_BaseSettingsItem.default, (0, _extends2.default)({
    title: title,
    isLoading: isLoading,
    badge: badge,
    icon: icon,
    hint: hint,
    controls: children && !disabled && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, collapsible && /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      container: true,
      direction: "row",
      justifyContent: "flex-end",
      xs: 3
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      id: title && "".concat(title, "_change"),
      "data-testid": "".concat((0, _utils.underscoreCase)(title), "_change"),
      variant: "contained",
      className: classes.button,
      onClick: toggleExpand,
      disabled: isLoading
    }, isExpanded ? 'Close' : buttonCta)), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
      className: classes.collapseWrapper,
      in: isExpanded,
      unmountOnExit: true
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      ml: 1
    }, children)))
  }, baseSettingsProps));
};

var _default = /*#__PURE__*/(0, _react.memo)(SettingsItem);

exports.default = _default;